export const routes = {
  login: '/',
  forgotPassword: '/forgotpassword',
  challenge: '/challenge',
  contactInformation: '/registration',
  generalOfficeInformation: '/registration/admin',
  additionalOfficeInformation: '/registration/office-info',
  workerClassification: '/registration/worker-classification',
  dashboardHome: '/',
  accountInformation: '/account/information',
  invoices: '/account/invoices',
  editOpenJob: '/dashboard/job/:jobId/edit',
  permanentJobDetails: '/dashboard/permanentJobs/:jobId',
  permanentJobs: '/dashboard/permanentJobs',
  inbox: '/dashboard/inbox',
  chat: '/dashboard/chat/:jobId',
  expiredCounterOffers: '/dashboard/jobs/:jobId/expired',
  selectDates: '/dashboard/shift-request/select-dates',
  multiDayShiftRequest: '/dashboard/multi-day/info',
  multiDayShiftAddInvites: '/dashboard/multi-day/add-invites',
  multiDayShiftConfirm: '/dashboard/multi-day/confirm',
  multiDayShiftEditRedesign: '/dashboard/multi-day/edit-shift/:dateIndex',
  permanentHireRequest: '/dashboard/pprs',
  transactionHistoryDetails: '/dashboard/receipts/transactions/:jobId',
  paymentHistory: '/dashboard/receipts',
  todaysJobs: '/dashboard/jobs/today',
  pendingReview: '/dashboard/jobs/pending-reviews',
  shiftsOverview: '/dashboard/jobs/:type',
  virtualJobRedirection: '/dashboard/job/:jobId/redirect',
  candidateProfile: '/dashboard/candidate/:jobId',
  professionalProfile: '/dashboard/professional/:professionalId',
  confirmCandidate: '/dashboard/job/:jobId/confirm/:candidateId',
  jobSummary: '/dashboard/job/:jobId/feedback',
  jobSummaryRating: '/dashboard/job/:jobId/feedback-rating',
  jobDetails: '/dashboard/job/:jobId/details',
  openJobDetails: '/dashboard/job/:jobId',
  npsReview: '/dashboard/nps',
  schedule: '/dashboard/calendar',
  paymentInformation: '/account/payment',
  referral: '/dashboard/referral',
  referralDisclaimer: '/dashboard/referral/disclaimer',
  help: '/help',
  about: '/help/about',
  notificationSettings: '/dashboard/notifications',
  cancellationFeedback: '/dashboard/feedback/:jobId',
  sendFeedback: '/account/feedback',
  jobAdjustment: '/dashboard/adjustments/:jobId',
  howItWorks: '/help/how-it-works',
  locumTenensDentist: '/dashboard/locum-tenens-dentist',
  workerClassificationType: '/account/worker-classification-type',
  workerClassificationManagement: '/account/worker-classification-management',
  professionalsHub: '/professionals-hub/:type',
  inviteProfessional: '/invite-professional',
  officeJobInvites: '/invites',
  account: '/account',
  bulkConfirmCandidateJobs: 'offices/:officeId/candidates/:candidateId/jobs',
  candidateJobDetail: '/dashboard/candidates/:candidateId/jobs/:jobId',
  termsAndConditions: '/dashboard/terms-and-conditions',
  signUpRedesign: {
    login: '/login',
    signUp: '/signup',
    forgotPassword: '/forgot-password',
    yourInfo: '/signup/your-info',
    officeDetails: '/signup/office-details',
    officeSetup: '/signup/office-setup',
    workerType: '/signup/worker-type',
  },
};
